import { render } from "./Footer.vue?vue&type=template&id=10a43ee6"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Footer.vue"]])

export default __exports__